import React from 'react';
import {Constants} from '../helpers';
const Signin = React.lazy(() => import('./SignInUser'));
const GoogleSignUpComplete = React.lazy(() =>
  import('./Auths/GoogleSignUpComplete'),
);
const ForgotPasswordUser = React.lazy(() => import('./ForgotPasswordUser'));
const ResetPasswordUser = React.lazy(() => import('./ResetPasswordUser'));
const Team = React.lazy(() => import('./Team'));
const CreatePasswordUser = React.lazy(() => import('./CreatePasswordUser'));
const Customer360 = React.lazy(() => import('./Customer360'));

import Dashboard from './Dashboard';
import QuickActions from './QuickActions';
import QuickActionsExisting from './QuickActions/Existing';
import AMLScreening from './AMLScreening';
import AMLScreeningResult from './AMLScreening/AMLScreeningResult';
import EasyLookup from './EasyLookup';
import IndividualLookup from './EasyLookup/IndividualLookup';
import EasyConnect from './EasyConnect';
import EasyOnboard from './EasyOnboard';
import FraudDetectionOverview from './FraudDetection/Overview';
import CustomLists from './FraudDetection/CustomLists';
import CustomListsItems from './FraudDetection/CustomLists/CustomListsItems';
import FraudDetectionOverviewPendingCases from './FraudDetection/Overview/PendingCases';
import FraudDetectionFlows from './FraudDetection/Flows';
import FraudDetectionFlowsAnalysis from './FraudDetection/Flows/Analysis';
import FraudDetectionFlowsCases from './FraudDetection/Flows/Cases';
import FraudDetectionFlowsCasesDetails from './FraudDetection/Flows/Cases/CasesDetails';
import FraudDetectionFlowsEventDetails from './FraudDetection/Flows/Events/EventDetails';
import FraudDetectionFlowsEventEvaluationResult from './FraudDetection/Flows/Events/EvaluationResult';
import FraudDetectionFlowsBehaviouralAnalysis from './FraudDetection/Flows/Cases/BehaviouralAnalysis';
import FraudDetectionFlowsSupportingDoc from './FraudDetection/Flows/Cases/SupportingDoc';
import FraudDetectionFlowsEvents from './FraudDetection/Flows/Events';
import FraudDetectionFlowsAccount from './FraudDetection/Flows/Account';
import FraudDetectionFlowsAccountTransactions from './FraudDetection/Flows/Account/AccountTransactions';
import FraudDetectionFlowsSettings from './FraudDetection/Flows/Settings';
// import FraudDetectionFlowsEditProcess from './FraudDetection/Flows/EditProcess';
import EasyOnboardCreateFlow from './EasyOnboard/CreateFlow';
import EasyOnboardCustomFlow from './EasyOnboard/CustomFlow';
import EasyOnboardUpdateFlow from './EasyOnboard/UpdateFlow';
import Verifications from './Verifications';
import PendingVerifications from './Verifications/PendingVerifications';
import VerificationsAddress from './Verifications/Address';
import VerificationsAmlCheck from './Verifications/AmlCheck';
import VerificationsBiodata from './Verifications/Biodata';
import VerificationsIpDeviceCheck from './Verifications/IpDeviceCheck';
import LinkAccounts from './LinkAccounts';
import SettingsProfile from './Settings/Profile';
import DevelopersApiLogs from './Developers/ApiLogs';
import DevelopersWebhook from './Developers/Webhook';
import DevelopersWebhookDetails from './Developers/WebhookDetails';
import DevelopersConfiguration from './Developers/Configuration';
import SettingsTeam from './Settings/Team';
import SettingsCompliance from './Settings/Compliance';
import SettingsBilling from './Settings/Billing';
import SettingsAuditLogs from './Settings/AuditLogs';
import SettingsOrganisation from './Settings/Organisation';
import SettingsTeamOwner from './Settings/Team/Owner';
import SettingsTeamLayout from './Settings/Team/Layout';
import SettingsBillingPricing from './Settings/Billing/BillingsTransactions';
import FailedGoogleLogin from '../components/AcountNotFound';
import AddressVerification from './AddressVerification';
import BatchAddressVerification from './AddressVerification/BatchUpload';
import IndividualSingleLookup from './EasyLookup/IndividualLookup/SingleLookup';
import IndividualBatchLookup from './EasyLookup/IndividualLookup/BatchLookup';
import BusinessLookup from './EasyLookup/BusinessLookup';
import BusinessSingleLookup from './EasyLookup/BusinessLookup/SingleLookup';
import BusinessBatchLookup from './EasyLookup/BusinessLookup/BatchLookup';
import ApiTokens from './Developers/ApiTokens';
import GlobalSearchResults from './EasyLookup/GlobalSearchResults';
import ApiStatus from './ApiStatus';
import EasyCreditCheck from './EasyCreditCheck';
import EasyCreditCheckSummary from './EasyCreditCheck/CreditSummary';
import EasyCreditAffordability from './EasyCreditCheck/Affordability';
import EasyCreditAmlScreening from './EasyCreditCheck/AmlScreening';
import EasyCreditBehaviouralAnalysis from './EasyCreditCheck/BehaviouralAnalysis';
import EasyCreditKycInformation from './EasyCreditCheck/KycInformation';
import ApiReport from './Report/ApiReport';
import EasyDetectReport from './Report/EasyDetectReport';
import AmlUserScreening from './AMLScreening/UserScreening';
import AmlBusinessScreening from './AMLScreening/BusinessScreening';
import AmlUserScreeningSingle from './AMLScreening/UserScreening/SingleScreening';
import AmlSearchResults from './AMLScreening/SearchResults';
import AmlUserScreeningBatch from './AMLScreening/UserScreening/BatchScreening';

import Customer360GovernmentLookup from './Customer360/GovernmentLookup';
import Customer360IpDeviceInfo from './Customer360/IPDeviceInfo';
import Customer360LivenessCheck from './Customer360/LivenessCheck';
import Customer360ValidationInfo from './Customer360/ValidationInfo';
import Customer360GovernmentID from './Customer360/GovernmentID';
import Customer360AddressInfo from './Customer360/AddressInfo';
import Customer360AmlCheck from './Customer360/AmlCheck';
import DocumentAnalysis from './DocumentAnalysis';
import SingleDocumentAnalysis from './DocumentAnalysis/SingleAnalysis';
import MessagingReport from './Report/MessagingReport';
import AmlBusinessScreeningSingle from './AMLScreening/BusinessScreening/SingleScreening';
import Business360 from './Business360';
import Business360BusinessLookup from './Business360/BusinessLookup';
import Business360BusinessId from './Business360/BusinessID';
import Business360AmlSearch from './Business360/AmlSearch';
import Business360DirectorInfo from './Business360/DirectorInfo';
import ProjectOverview from './FraudDetection/Reconciliation/Projects/ProjectOverview';
import ProjectAccounts from './FraudDetection/Reconciliation/Projects/ProjectAccounts';
import Projects from './FraudDetection/Reconciliation/Projects';
import ProjectTransactions from './FraudDetection/Reconciliation/Projects/ProjectTransactions';
import ProjectReconciliation from './FraudDetection/Reconciliation/Projects/ProjectReconciliation';
import ProjectCustomers from './FraudDetection/Reconciliation/Projects/ProjectCustomers';
import ProjectSettings from './FraudDetection/Reconciliation/Projects/ProjectSettings';
import Overview from './FraudDetection/Reconciliation/Overview';
import Transactions from './FraudDetection/Reconciliation/Transactions';
import Reconciliation from './FraudDetection/Reconciliation/Reconciliation';
import Customers from './FraudDetection/Reconciliation/Customers';
import CustomerDetails from './FraudDetection/Reconciliation/Customers/CustomerDetails';
import ProjectAccountDetails from './FraudDetection/Reconciliation/Projects/ProjectAccountDetails';
import VerificationAnalytics from './Verifications/VerificationAnalytics';
import Signup from './FraudDetection/Reconciliation/Auth/Signup';
import ReconciloSignIn from './FraudDetection/Reconciliation/Auth/ReconciloSignIn';
import ForgotPassword from './FraudDetection/Reconciliation/Auth/ForgotPassword';
import SetPassword from './FraudDetection/Reconciliation/Auth/SetPassword';
import ResetPassword from './FraudDetection/Reconciliation/Auth/ResetPassword';
import GoogleSignup from './FraudDetection/Reconciliation/Auth/GoogleSignup';
import Billing from './FraudDetection/Reconciliation/Billing';
import BillingPaymentHistory from './FraudDetection/Reconciliation/BillingPaymentHistory';
import Index from './FraudDetection/Baas';
import BaasTransactions from './FraudDetection/Baas/BaasTransactions';
import BaasWallets from './FraudDetection/Baas/BaasWallets';
import BaasPayouts from './FraudDetection/Baas/BaasPayouts';
import BaasSettings from './FraudDetection/Baas/BaasSettings';
import BaasAccountDetails from './FraudDetection/Baas/BaasAccountDetails';
import AuthenticationAnalytics from './EasyAuthentication/AuthenticationAnalytics';
import AuthenticationCustomers from './EasyAuthentication/AuthenticationCustomers';
import Authentications from './EasyAuthentication/Authentications';
import Bio from './EasyAuthentication/Authentications/Bio';
import IpDeviceCheck from './EasyAuthentication/Authentications/IpDeviceCheck';
import BehavioralScore from './EasyAuthentication/Authentications/BehavioralScore';
import AuthenticationFlow from './EasyAuthentication/AuthenticationFlow';
import CreateAuthFlow from './EasyAuthentication/AuthenticationFlow/CreateAuthFlow';
import UpdateAuthFlow from './EasyAuthentication/AuthenticationFlow/UpdateAuthFlow';
import OnboardingRedirect from './FraudDetection/Reconciliation/Auth/OnboardingRedirect';
import IndividualAccounts from './FraudDetection/Flows/Cases/Rules/IndividualAccounts';
import CorporateAccounts from './FraudDetection/Flows/Cases/Rules/CorporateAccounts';
import BehaviouralMonitoring from './FraudDetection/Flows/Cases/Rules/BehaviouralMonitoring';
import CompanyVerification from './Settings/CompanyVerification';
import AuditLogs from './Logs/AuditLogs';
import ExportLogs from './Logs/ExportLogs';
import BaasCustomers from './FraudDetection/Baas/customers/Index';
import CustomerTransactions from './FraudDetection/Baas/customers/components/CustomerTransactions';
import CustomerWallets from './FraudDetection/Baas/customers/components/CustomerWallets';
import CustomerCards from './FraudDetection/Baas/customers/components/CustomerCards';
import CustomerCardDetails from './FraudDetection/Baas/customers/CustomerCardDetails';
import CustomerWalletDetails from './FraudDetection/Baas/customers/CustomerWalletDetails';
import UpdatedEditProcess from './FraudDetection/Flows/UpdatedEditProcess';
import FLowVersionRules from './FraudDetection/Flows/UpdatedEditProcess/VersionRules';
import FlowsAccountIndex from './FraudDetection/Flows/Accounts';
import SingleAccount from './FraudDetection/Flows/Accounts/singleAccount';
import SingleAccountEvents from './FraudDetection/Flows/Accounts/singleAccount/Events';
import SingleAccountCases from './FraudDetection/Flows/Accounts/singleAccount/Cases';
import BehaviouralAnalysis from './FraudDetection/Flows/Events/BehaviouralAnalysis';
import AMLScreeningNew from './AMLScreening/AMLScreeningNew';
import AMLScreeningResults from './AMLScreening/AMLScreeningResults';
import AMLScreeningSingleResult from './AMLScreening/AMLScreeningSingleResult';
import EmailNotifications from './Settings/EmailNotifications';
import FlowTemplates from './FraudDetection/Flows/FlowTemplates/Index';
import FlowTemplateDetails from './FraudDetection/Flows/FlowTemplates/FlowTemplateDetails';
import AllAccounts from './FraudDetection/Flows/Accounts/AllAccounts';
import VeldroOverview from './Veldro/Overview';
import VeldroBusinesses from './Veldro/Businesses';
import ReportedInvoices from './Veldro/ReportedInvoices';
import VeldroSingleBusiness from './Veldro/SingleBusiness';
import SentInvoices from './Veldro/SentInvoices';
import ReceivedInvoices from './Veldro/ReceivedInvoices';
import ProfiledRiskOverview from './ProfiledRisk/Overview';
import ProfiledRiskProfiles from './ProfiledRisk/Profiles';
import ProfileRiskDetails from './ProfiledRisk/ProfileDetails';
import ApiAnalysis from './ApiAnalysis/Index';
import ProfiledRiskBillings from './ProfiledRisk/Billings';
// import ProfiledRiskEvents from './ProfiledRisk/Billings/Events';
import ProfiledRiskUpgrade from './ProfiledRisk/Billings/Upgrade';
import Configuration from './ProfiledRisk/Settings/Configuration';

const baseRoutes = {
  private: [
    {
      component: <Dashboard />,
      exact: true,
      path: Constants.PAGES_URL.DASHBOARD,
    },

    {
      component: <QuickActions />,
      exact: true,
      path: Constants.PAGES_URL.QUICKACTIONS,
    },
    {
      component: <QuickActionsExisting />,
      exact: true,
      path: Constants.PAGES_URL.QUICKACTIONS_EXISTING,
    },
    {
      component: <EasyLookup />,
      exact: true,
      path: Constants.PAGES_URL.EASY_LOOKUP,
    },
    {
      component: <AMLScreening />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_OLD,
    },
    {
      component: <AuthenticationCustomers />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_CUSTOMERS,
    },
    {
      component: <Authentications />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS,
    },
    {
      component: <Bio />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS_BIO_DATA,
    },
    {
      component: <IpDeviceCheck />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS_IP_DEVICE_CHECK,
    },
    {
      component: <BehavioralScore />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATIONS_BEHAVIORAL_SCORE,
    },
    {
      component: <AuthenticationAnalytics />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_ANALYTICS,
    },
    {
      component: <AuthenticationFlow />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_FLOW,
    },
    {
      component: <CreateAuthFlow />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_FLOW_CUSTOM,
    },
    {
      component: <UpdateAuthFlow />,
      exact: true,
      path: Constants.PAGES_URL.AUTHENTICATION_FLOW_UPDATE,
    },
    {
      component: <IndividualLookup />,
      exact: true,
      path: Constants.PAGES_URL.INDIVIDUAL_LOOKUP,
    },
    {
      component: <EmailNotifications />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_EMAIL_NOTIFICATIONS,
    },
    {
      component: <ProfiledRiskOverview />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_OVERVIEW,
    },
    {
      component: <ProfiledRiskBillings />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_TRANSACTIONS,
    },
    {
      component: <Configuration />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_CONFIGURATION,
    },
    {
      // component: <ProfiledRiskEvents />,
      component: <FraudDetectionFlowsEvents />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_EVENTS,
    },
    {
      component: <ProfiledRiskUpgrade />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_UPGRADE,
    },
    {
      component: <ProfiledRiskProfiles />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_PROFILES,
    },
    {
      component: <ProfileRiskDetails />,
      exact: true,
      path: Constants.PAGES_URL.PROFILED_RISK_PROFILE_DETAILS,
    },
    {
      component: <IndividualSingleLookup />,
      exact: true,
      path: Constants.PAGES_URL.INDIVIDUAL_LOOKUP_SINGLE,
    },
    {
      component: <IndividualBatchLookup />,
      exact: true,
      path: Constants.PAGES_URL.INDIVIDUAL_LOOKUP_BATCH,
    },
    {
      component: <BusinessLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_LOOKUP,
    },
    {
      component: <BusinessSingleLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_LOOKUP_SINGLE,
    },
    {
      component: <BusinessBatchLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_LOOKUP_BATCH,
    },
    {
      component: <EasyConnect />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CONNECT,
    },

    {
      component: <EasyOnboard />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD,
    },
    {
      component: <EasyOnboardCreateFlow />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD_CREATE_FLOW,
    },
    {
      component: <EasyOnboardCustomFlow />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD_CUSTOM_FLOW,
    },
    {
      component: <EasyOnboardUpdateFlow />,
      exact: true,
      path: Constants.PAGES_URL.EASY_ONBOARD_UPDATE_FLOW,
    },
    {
      component: <FraudDetectionOverview />,
      exact: true,
      path: Constants.PAGES_URL.OVERVIEW,
    },
    {
      component: <AuditLogs />,
      exact: true,
      path: Constants.PAGES_URL.AUDIT_LOGS,
    },
    {
      component: <ExportLogs />,
      exact: true,
      path: Constants.PAGES_URL.EXPORT_LOGS,
    },
    {
      component: <VeldroOverview />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_OVERVIEW,
    },
    {
      component: <VeldroBusinesses />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_BUSINESSES,
    },
    {
      component: <VeldroSingleBusiness />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_SINGLE_BUSINESS,
    },
    {
      component: <SentInvoices />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_SENT_INVOICES,
    },
    {
      component: <ReceivedInvoices />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_RECEIVED_INVOICES,
    },
    {
      component: <ReportedInvoices />,
      exact: true,
      path: Constants.PAGES_URL.VELDRO_REPORTED_INVOICES,
    },
    {
      component: <CustomLists />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOM_LISTS,
    },
    {
      component: <CustomListsItems />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOM_LISTS_ITEMS,
    },
    {
      component: <FraudDetectionOverviewPendingCases />,
      exact: true,
      path: Constants.PAGES_URL.OVERVIEW_PENDING_CASES,
    },
    {
      component: <FraudDetectionFlows />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS,
    },
    {
      component: <FraudDetectionFlowsAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ANALYTICS,
    },
    {
      component: <IndividualAccounts />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_INDIVIDUAL,
    },
    {
      component: <CorporateAccounts />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_CORPORATE,
    },
    {
      component: <BehaviouralMonitoring />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_BEHAVIOURAL_MONITORING,
    },
    // old aml
    {
      component: <AMLScreeningResult />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_RESULT,
    },
    // new aml
    {
      component: <AMLScreeningResults />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_RESULTS,
    },
    // new aml
    {
      component: <AMLScreeningSingleResult />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING_SINGLE_RESULT,
    },

    {
      component: <ProjectOverview />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_OVERVIEW,
    },
    {
      component: <ProjectReconciliation />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_RECONCILIATION,
    },

    {
      component: <ProjectCustomers />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_CUSTOMERS,
    },
    {
      component: <ProjectSettings />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_SETTINGS,
    },
    {
      component: <ProjectTransactions />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_TRANSACTIONS,
    },
    {
      component: <ProjectAccounts />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_ACCOUNTS,
    },
    {
      component: <ProjectAccountDetails />,
      exact: true,
      path: Constants.PAGES_URL.PROJECT_ACCOUNTS_DETAILS,
    },
    {
      component: <Projects />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_PROJECTS,
    },
    {
      component: <Overview />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_OVERVIEW,
    },
    {
      component: <Transactions />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_TRANSACTIONS,
    },
    {
      component: <Reconciliation />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION,
    },
    {
      component: <Customers />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_CUSTOMERS,
    },
    {
      component: <CustomerDetails />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_CUSTOMER_DETAILS,
    },

    {
      component: <FraudDetectionFlowsEventDetails />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENT_DETAILS,
    },
    {
      component: <FraudDetectionFlowsEventEvaluationResult />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENT_RESULT_EVALUATION,
    },
    {
      component: <BehaviouralAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENT_BEHAVIOURAL_ANALYSIS,
    },
    {
      component: <FraudDetectionFlowsCases />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES,
    },
    {
      component: <FraudDetectionFlowsCasesDetails />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_DETAILS,
    },
    {
      component: <FraudDetectionFlowsCasesDetails />,
      exact: true,
      path: Constants.PAGES_URL.PENDING_CASES_DETAILS,
    },
    {
      component: <FraudDetectionFlowsBehaviouralAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_BEHAVIOURAL_ANALYSIS,
    },
    {
      component: <FraudDetectionFlowsSupportingDoc />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_CASES_SUPPORTING_DOC,
    },
    {
      component: <FraudDetectionFlowsCasesDetails />,
      exact: true,
      path: Constants.PAGES_URL.PENDING_CASES_DETAILS,
    },
    {
      component: <FraudDetectionFlowsEvents />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EVENTS,
    },
    {
      component: <FraudDetectionFlowsAccount />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNT,
    },
    {
      component: <FlowsAccountIndex />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS,
    },
    {
      component: <AllAccounts />,
      exact: true,
      path: Constants.PAGES_URL.ACCOUNTS,
    },
    {
      component: <SingleAccount />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS_OVERVIEW,
    },
    {
      component: <SingleAccountEvents />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS_EVENTS,
    },
    {
      component: <SingleAccountCases />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNTS_CASES,
    },
    {
      component: <FraudDetectionFlowsAccountTransactions />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_ACCOUNT_TRANSACTIONS,
    },
    {
      component: <FraudDetectionFlowsSettings />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_SETTINGS,
    },
    {
      // component: <FraudDetectionFlowsEditProcess />,
      component: <UpdatedEditProcess />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_EDIT_PROCESS,
    },
    {
      // component: <FraudDetectionFlowsEditProcess />,
      component: <FLowVersionRules />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_VERSION_RULES,
    },
    {
      component: <FlowTemplates />,
      exact: true,
      path: Constants.PAGES_URL.FLOW_TEMPLATES,
    },
    {
      component: <FlowTemplateDetails />,
      exact: true,
      path: Constants.PAGES_URL.FLOW_TEMPLATE_DETAILS,
    },
    {
      component: <UpdatedEditProcess />,
      exact: true,
      path: Constants.PAGES_URL.FLOWS_UPDATED_EDIT_PROCESS,
    },
    {
      component: <Verifications />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS,
    },
    {
      component: <VerificationAnalytics />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATION_ANALYTICS,
    },
    {
      component: <PendingVerifications />,
      exact: true,
      path: Constants.PAGES_URL.PENDING_VERIFICATIONS,
    },
    {
      component: <VerificationsAddress />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_ADDRESS,
    },
    {
      component: <VerificationsAmlCheck />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_AML_CHECK,
    },
    {
      component: <VerificationsBiodata />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_BIO_DATA,
    },
    {
      component: <VerificationsIpDeviceCheck />,
      exact: true,
      path: Constants.PAGES_URL.VERIFICATIONS_IP_DEVICE_CHECK,
    },
    {
      component: <LinkAccounts />,
      exact: true,
      path: Constants.PAGES_URL.LINK_ACCOUNTS,
    },
    {
      component: <DevelopersApiLogs />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_API_LOGS,
    },
    {
      component: <DevelopersWebhook />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_WEBHOOK,
    },
    {
      component: <ApiAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.API_ANALYSIS,
    },
    {
      component: <ApiStatus />,
      exact: true,
      path: Constants.PAGES_URL.API_STATUS,
    },
    {
      component: <DevelopersWebhookDetails />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_WEBHOOK_DETAILS,
    },
    {
      component: <DevelopersConfiguration />,
      exact: true,
      path: Constants.PAGES_URL.DEVELOPERS_CONFIGURATION,
    },
    {
      component: <SettingsProfile />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_PROFILE,
    },
    {
      component: <SettingsCompliance />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_COMPLIANCE,
    },
    {
      component: <SettingsTeam />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_TEAM,
    },
    {
      component: <SettingsTeamOwner />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_TEAM_OWNER,
    },
    {
      component: <SettingsAuditLogs />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_AUDIT_LOGS,
    },
    {
      component: <SettingsOrganisation />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_ORGANISATION,
    },
    {
      component: <SettingsBilling />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_BILLING,
    },
    {
      component: <SettingsBillingPricing />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_BILLING_PRICING,
    },
    {
      component: <SettingsTeamLayout />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_TEAM_LAYOUT,
    },
    {
      component: <AddressVerification />,
      exact: true,
      path: Constants.PAGES_URL.ADDRESS_VERIFICATION,
    },
    {
      component: <CompanyVerification />,
      exact: true,
      path: Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION,
    },
    {
      component: <BatchAddressVerification />,
      exact: true,
      path: Constants.PAGES_URL.BATCH_ADDRESS_VERIFICATION,
    },
    {
      component: <ApiTokens />,
      exact: true,
      path: Constants.PAGES_URL.API_TOKENS,
    },
    {
      component: <GlobalSearchResults />,
      exact: true,
      path: Constants.PAGES_URL.GLOBAL_SEARCH_RESULTS,
    },
    {
      component: <EasyCreditCheck />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_CHECK,
    },
    {
      component: <EasyCreditCheckSummary />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_CREDIT_SUMMARY,
    },
    {
      component: <EasyCreditAffordability />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_AFFORDABILITY,
    },
    {
      component: <EasyCreditAmlScreening />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_AML_SCREENING,
    },
    {
      component: <EasyCreditBehaviouralAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_BEHAVIOURAL_ANALYSIS,
    },
    {
      component: <EasyCreditKycInformation />,
      exact: true,
      path: Constants.PAGES_URL.EASY_CREDIT_KYC_INFORMATION,
    },
    {
      component: <ApiReport />,
      exact: true,
      path: Constants.PAGES_URL.API_REPORT,
    },
    {
      component: <EasyDetectReport />,
      exact: true,
      path: Constants.PAGES_URL.EASY_DETECT_REPORT,
    },
    {
      component: <AmlUserScreening />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING,
    },
    {
      component: <AMLScreeningNew />,
      exact: true,
      path: Constants.PAGES_URL.AML_SCREENING,
    },
    {
      component: <AmlUserScreeningSingle />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING_SINGLE,
    },
    {
      component: <AmlUserScreeningBatch />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING_BATCH,
    },
    {
      component: <AmlBusinessScreening />,
      exact: true,
      path: Constants.PAGES_URL.AML_BUSINESS_SCREENING,
    },
    {
      component: <AmlSearchResults />,
      exact: true,
      path: Constants.PAGES_URL.AML_USER_SCREENING_SEARCH_RESULTS,
    },
    {
      component: <AmlSearchResults />,
      exact: true,
      path: Constants.PAGES_URL.AML_BUSINESS_SCREENING_SEARCH_RESULTS,
    },
    {
      component: <Customer360 />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360,
    },
    {
      component: <Customer360GovernmentLookup />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_GOVT_LOOKUP,
    },
    {
      component: <Customer360IpDeviceInfo />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_IP_DEVICE_INFO,
    },
    {
      component: <Customer360LivenessCheck />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_LIVENESS_CHECK,
    },
    {
      component: <Customer360ValidationInfo />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_VALIDATION_INFO,
    },
    {
      component: <Customer360GovernmentID />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_GOVT_ID,
    },
    {
      component: <Customer360AddressInfo />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_ADDRESS_INFO,
    },
    {
      component: <Customer360AmlCheck />,
      exact: true,
      path: Constants.PAGES_URL.CUSTOMER_360_AML_CHECK,
    },
    {
      component: <DocumentAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.DOCUMENT_ANALYSIS,
    },
    {
      component: <SingleDocumentAnalysis />,
      exact: true,
      path: Constants.PAGES_URL.DOCUMENT_ANALYSIS_SINGLE,
    },
    {
      component: <MessagingReport />,
      exact: true,
      path: Constants.PAGES_URL.MESSAGING_REPORT,
    },
    {
      component: <AmlBusinessScreeningSingle />,
      exact: true,
      path: Constants.PAGES_URL.AML_BUSINESS_SCREENING_SINGLE,
    },
    {
      component: <Business360 />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360,
    },
    {
      component: <Business360BusinessLookup />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_BUSINESS_LOOKUP,
    },
    {
      component: <Business360BusinessId />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_BUSINESS_ID,
    },
    {
      component: <Business360AmlSearch />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_AML_SEARCH,
    },
    {
      component: <Business360DirectorInfo />,
      exact: true,
      path: Constants.PAGES_URL.BUSINESS_360_DIRECTOR_INFO,
    },
    {
      component: <Billing />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_BILLING,
    },
    {
      component: <BillingPaymentHistory />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_BILLING_HISTORY,
    },
    {
      component: <Index />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_OVERVIEW,
    },
    {
      component: <BaasTransactions />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_TRANSACTIONS,
    },
    {
      component: <BaasWallets />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_WALLETS,
    },
    {
      component: <BaasPayouts />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_PAYOUTS,
    },
    {
      component: <BaasSettings />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_SETTINGS,
    },
    {
      component: <BaasCustomers />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS,
    },
    {
      component: <CustomerTransactions />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_TRANSACTIONS,
    },
    {
      component: <CustomerWallets />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_WALLETS,
    },
    {
      component: <CustomerCards />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_CARDS,
    },
    {
      component: <CustomerCardDetails />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_CARD_DETAILS,
    },
    {
      component: <CustomerWalletDetails />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_CUSTOMERS_WALLET_DETAILS,
    },
    {
      component: <BaasAccountDetails />,
      exact: true,
      path: Constants.PAGES_URL.BAAS_ACCOUNT_DETAIL,
    },
  ],
  public: [
    {
      component: <Signin />,
      exact: true,
      path: Constants.PAGES_URL.SIGNIN,
    },

    {
      component: <GoogleSignup />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_GOOGLE_SIGN_UP,
    },

    {
      component: <ForgotPasswordUser />,
      exact: true,
      path: Constants.PAGES_URL.FORGOT_PASSWORD,
    },
    {
      component: <ResetPasswordUser />,
      exact: true,
      path: Constants.PAGES_URL.RESET_PASSWORD,
    },
    {
      component: <OnboardingRedirect />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_REDIRECT,
    },
    {
      component: <Team />,
      exact: true,
      path: Constants.PAGES_URL.TEAM,
    },
    {
      component: <CreatePasswordUser />,
      exact: true,
      path: Constants.PAGES_URL.CREATE_PASSWORD,
    },
    {
      component: <FailedGoogleLogin />,
      exact: true,
      path: Constants.PAGES_URL.ACCOUNT_NOT_FOUND,
    },
    {
      component: <GoogleSignUpComplete />,
      exact: true,
      path: '/',
    },
    {
      component: <Signup />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_SIGNUP,
    },
    {
      component: <ReconciloSignIn />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_SIGNIN,
    },
    {
      component: <ForgotPassword />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_FORGOT_PASSWORD,
    },
    {
      component: <SetPassword />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_SET_PASSWORD,
    },
    {
      component: <ResetPassword />,
      exact: true,
      path: Constants.PAGES_URL.RECONCILIATION_RESET_PASSWORD,
    },
  ],
};

export default baseRoutes;
